import styled from "styled-components";

export const SummaryCard = styled.div`
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: ${(p) => p.theme.tokens.radii.lg}px;
  margin: 0 14px 14px;
  padding: 16px;
  box-shadow: ${(p) => p.theme.tokens.shadows.card};
  border: 1px solid ${(p) => p.theme.tokens.colors.softBg};
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
  margin-top: 12px;
`;

export const SpinnerWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
`;
